/**
 * This service is specific to the context where the portal is deployed, setting styles on the
 * navigation links contained in the index.html.
 * It is expected that this service would need to be changed to adapt to the navigation markup of the containing page
 */

export default ['$rootScope', '$state', ($rootScope, $state) => {
    let initialised = false;

    const init = () => {
        initialised = true;
        $rootScope.$on('$stateChangeSuccess', () => {
            let topLevelNavId = 'home';
            const currentState = $state.$current.name;


            if (currentState.indexOf('baseFnolWizard') !== -1 || currentState.indexOf('claim') !== -1) {
                topLevelNavId = 'claims';
            }

            $('.top-level li').removeClass('active');
            $(`#${topLevelNavId}-top-nav`).addClass('active');
        });
    };

    return {
        initialiseTopLevelListener: () => {
            if (!initialised) {
                init();
            }
        }
    };
}];